import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getLocationDetails } from '../../utilities/api';

export const fetchLocationData = createAsyncThunk('location/fetch', async ({ rolename, clientname }, { rejectWithValue }) => {
    try {
        const data = await getLocationDetails({ rolename, clientname });
        return data;
    } catch (error) {
        return rejectWithValue(error.message || 'Failed to fetch location data');
    }
});

const initialState = {
    clients: [],
    allBranchs: [],
    locations: [],
    loading: true,
    error: null,
    selectedClient: null,
    selectedBranch: null
};

const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {
        setSelectedClient: (state, action) => {
            state.selectedClient = action.payload;
            state.selectedBranch = null;
        },
        setSelectedBranch: (state, action) => {
            state.selectedBranch = action.payload;
        },
        resetFilters: (state) => {
            state.selectedClient = null;
            state.selectedBranch = null;
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchLocationData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLocationData.fulfilled, (state, action) => {
                state.loading = false;
                const raw = action.payload || {};
                state.clients = Array.isArray(raw.clients) ? raw.clients : [];
                state.allBranchs = Array.isArray(raw.branchs) ? raw.branchs : [];
                state.locations = Array.isArray(raw.company) ? raw.company : [];
            })
            .addCase(fetchLocationData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { setSelectedClient, setSelectedBranch, resetFilters } = locationSlice.actions;

export const selectClients = (state) => state.location.clients;
export const selectAllBranchs = (state) => state.location.allBranchs;
export const selectLocations = (state) => state.location.locations;
export const selectLoading = (state) => state.location.loading;
export const selectError = (state) => state.location.error;
export const selectSelectedClient = (state) => state.location.selectedClient;
export const selectSelectedBranch = (state) => state.location.selectedBranch;

export const selectFilteredBranches = (state) => {
    const { allBranchs, selectedClient } = state.location;
    if (!selectedClient) return [];
    return allBranchs.filter((b) => String(b.client_id) === String(selectedClient.client_id));
};

export const selectFilteredLocations = (state) => {
    const { locations, selectedClient, selectedBranch } = state.location;
    let result = [...locations];
    if (selectedClient) result = result.filter((l) => String(l.client_id) === String(selectedClient.client_id));
    if (selectedBranch) result = result.filter((l) => String(l.branch_id) === String(selectedBranch.branch_id));
    return result;
};

export default locationSlice.reducer;
